/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ReportListResource } from '../models/ReportListResource';
import type { ReportResource } from '../models/ReportResource';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ReportService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Lister les modeles de rapport
     * Tous les modeles de rapport (formulaires a etapes) de l'entreprise, sans leurs questions.
     * @returns ReportResource Array of `ReportResource`
     * @throws ApiError
     */
    public reportIndex(): CancelablePromise<Array<ReportResource>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/report',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Creer un modele de rapport
     * `name`, `description` et des `steps`, chacune avec ses `questions` (`label`, `field_type_id` parmi les types de champ existants, `constraints` optionnelles, filtrees selon celles que le type autorise). En cas d'erreur sur une etape ou une question, rien n'est enregistre (422 avec le detail).
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public reportStore(
        requestBody: {
            name: string;
            description?: string | null;
            steps: Array<{
                name: string;
                questions: Array<{
                    label: string;
                    field_type_id: number;
                    constraints?: any[] | null;
                }>;
            }>;
        },
    ): CancelablePromise<{
        message: string;
        report: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/report',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Detail d'un modele de rapport
     * Avec ses etapes et leurs questions, pret a etre rendu en formulaire.
     * @param id
     * @returns ReportListResource `ReportListResource`
     * @throws ApiError
     */
    public reportShow(
        id: string,
    ): CancelablePromise<ReportListResource> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/report/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Renommer un modele de rapport
     * Ne modifie que `name` et `description` ; les etapes et questions ne sont pas editables (recreer le modele). Reponse : `{ message, report }`.
     * @param id
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public reportUpdate(
        id: string,
        requestBody: {
            name: string;
            description?: string | null;
        },
    ): CancelablePromise<{
        message: string;
        report: string;
    }> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/report/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Supprimer un modele de rapport
     * Avec ses etapes et ses questions.
     * @param id
     * @returns any
     * @throws ApiError
     */
    public reportDestroy(
        id: string,
    ): CancelablePromise<{
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/report/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
}
